var $cartWrapper = document.querySelector('.cart-wrapper'),
	cartOptions = {
		closeCart: function() {
			if(window.vueSideCart){
				window.vueSideCart.closeCart();
			}
			// if ($cartWrapper.classList.contains('open')) {
			// 	document.documentElement.classList.remove('coto_lock-scroll');
			// 	document.documentElement.classList.remove('content-overlay');
			// 	$cartWrapper.classList.remove('open');
			// }
		},
		openCart: function() {
			if(window.vueSideCart){
				window.vueSideCart.openCart();
			}
			
			// if (!$cartWrapper.classList.contains('open')) {
			// 	document.documentElement.classList.add('coto_lock-scroll');
			// 	document.documentElement.classList.add('content-overlay');
			// 	$cartWrapper.classList.add('open');
			// 	//load the images on open
			// 	var $lazyCartImage = document.querySelectorAll('.lazy-cart');
			// 	for (let $image of $lazyCartImage) {
			// 		let notLoaded = $image.classList.contains('lazy-cart');
		
			// 		if (notLoaded) {
			// 			var srcPath = $image.dataset.src;
		
			// 			$image.src = srcPath;
			// 			setTimeout(function() {
			// 				$image.removeAttribute('data-src');
			// 				$image.classList.remove('lazy-cart');
			// 			}, 10);
			// 		}
			// 	};
			// }
		}
	};

module.exports = cartOptions;